import React from 'react';

import { StatusDialog, AssignDialog, ScheduleDialog, NoteDialog } from './ListActionDialogParts';
import { StatusOption } from './useListJobActions';

export interface ListActionDialogsProps {
  activeDialog: 'status' | 'assign' | 'schedule' | 'note' | null;
  targetIds: number[];
  onClose: () => void;
  statusOptions: StatusOption[];
  statusLoading: boolean;
  onSubmitStatus: (code: string, notes: string) => Promise<void>;
  onSubmitAllocation: (nodeId: number, typeCode: string) => Promise<void>;
  onSubmitSchedule: (date: string) => Promise<void>;
  onSubmitNote: (note: string) => Promise<void>;
  submitting: boolean;
  lastError: string | null;
}

/** Renders all action dialogs -- only the active one is visible. */
export const ListActionDialogs: React.FC<ListActionDialogsProps> = ({
  activeDialog, targetIds, onClose,
  statusOptions, statusLoading, onSubmitStatus,
  onSubmitAllocation, onSubmitSchedule, onSubmitNote,
  submitting, lastError,
}) => {
  const isBulk = targetIds.length > 1;
  const count = targetIds.length;

  return (
    <>
      <StatusDialog
        open={activeDialog === 'status'}
        isBulk={isBulk}
        count={count}
        options={statusOptions}
        loading={statusLoading}
        submitting={submitting}
        lastError={activeDialog === 'status' ? lastError : null}
        onClose={onClose}
        onSubmit={onSubmitStatus}
      />
      <AssignDialog
        open={activeDialog === 'assign'}
        isBulk={isBulk}
        count={count}
        submitting={submitting}
        lastError={activeDialog === 'assign' ? lastError : null}
        onClose={onClose}
        onSubmit={onSubmitAllocation}
      />
      <ScheduleDialog
        open={activeDialog === 'schedule'}
        isBulk={isBulk}
        count={count}
        submitting={submitting}
        lastError={activeDialog === 'schedule' ? lastError : null}
        onClose={onClose}
        onSubmit={onSubmitSchedule}
      />
      <NoteDialog
        open={activeDialog === 'note'}
        isBulk={isBulk}
        count={count}
        submitting={submitting}
        lastError={activeDialog === 'note' ? lastError : null}
        onClose={onClose}
        onSubmit={onSubmitNote}
      />
    </>
  );
};
